/* eslint-disable no-unused-vars */
/* eslint-disable radix */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import { MdOutlineTimer } from 'react-icons/md';
import {
  clearLocalStorage,
  getStringFromLS,
} from './shared/helper-utils/localStorage';
import { SESSION_TIME } from './shared/constants/Constants';
import AppButton from './shared/components/app-button/AppButton';
import { APP_TIME_STAMP, APP_USER_AUTH } from './saas/AppStorageStaticNames';

function TimeoutProvider({ children }) {
  const userAuth = getStringFromLS(APP_USER_AUTH);
  const [showModal, setShowModal] = useState(false);
  const timeoutRef = useRef(null);

  const handleSessionTimeout = () => {
    clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      setShowModal(true);
    }, SESSION_TIME);
  };

  const handleStorageChange = (event) => {
    if (event.key === APP_TIME_STAMP) {
      handleSessionTimeout();
    }
  };

  useEffect(() => {
    window.addEventListener('storage', handleStorageChange);
    // Initial session timeout setup
    handleSessionTimeout();
    // Cleanup function
    return () => {
      clearTimeout(timeoutRef.current);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const handleLogin = () => {
    clearLocalStorage();
    window.location.href = '/login';
  };

  return userAuth ? (
    <>
      <Modal show={showModal}>
        <Modal.Body>
          <div className="d-flex justify-content-center align-items-center flex-column">
            <MdOutlineTimer className="fs-1" />
            <span>Your session has expired. Please login again.</span>
            <span className="fs-10">
              Note: You will be redirected to login page.
            </span>
            <AppButton
              btnText="login"
              onClick={handleLogin}
              className="px-4 mt-4"
            />
          </div>
        </Modal.Body>
      </Modal>
      {children}
    </>
  ) : (
    children
  );
}

export default TimeoutProvider;
